import _ from 'lodash';
import TransactionStorage from "utilities/TransactionStorage";
import sendOfflinePostRequests from "utilities/request/sendOfflinePostRequests";
import Request from "utilities/Request";

export const SEARCH_TRANSACTIONS_TEXT_CHANGE = 'SEARCH_TRANSACTIONS_TEXT_CHANGE';
export const SEARCH_TRANSACTIONS_ON_PAGE = 'SEARCH_TRANSACTIONS_ON_PAGE';

export const OFFLINE_TRANSACTION_REMOVE_BEGIN = 'OFFLINE_TRANSACTION_REMOVE_BEGIN';
export const OFFLINE_TRANSACTION_REMOVE_SUCCESS = 'OFFLINE_TRANSACTION_REMOVE_SUCCESS';
export const OFFLINE_TRANSACTION_REMOVE_FAIL = 'OFFLINE_TRANSACTION_REMOVE_FAIL';

export const OFFLINE_TRANSACTION_LIST_UPDATE_BEGIN = 'OFFLINE_TRANSACTION_LIST_UPDATE_BEGIN';
export const OFFLINE_TRANSACTION_LIST_UPDATE_SUCCESS = 'OFFLINE_TRANSACTION_LIST_UPDATE_SUCCESS';

export const FORCE_SEND_OFFLINE_TRANSACTION_LIST_BEGIN = 'FORCE_SEND_OFFLINE_TRANSACTION_LIST_BEGIN';
export const FORCE_SEND_OFFLINE_TRANSACTION_LIST_SUCCESS = 'FORCE_SEND_OFFLINE_TRANSACTION_LIST_SUCCESS';
export const FORCE_SEND_OFFLINE_TRANSACTION_LIST_FAIL = 'FORCE_SEND_OFFLINE_TRANSACTION_LIST_FAIL';


export const SEARCH_TRANSACTIONS_SORT_CHANGE = 'SEARCH_TRANSACTIONS_SORT_CHANGE';

/**
 * The search box's text is in the store at once; the query the list is searched with follows it
 * after a pause in typing, since rendering the results is what costs.
 */
const debouncedSearch = _.debounce((text, dispatch) => {
	dispatch({
		type: SEARCH_TRANSACTIONS_ON_PAGE,
		payload: text
	});
}, 150);

export const searchTransactions = (text) => (dispatch) => {
	dispatch({
		type: SEARCH_TRANSACTIONS_TEXT_CHANGE,
		payload: text
	});
	debouncedSearch(text, dispatch);
};

/** Best match or newest first (utilities/transactionFinder/transactionSearch.js), remembered per browser. */
export const setTransactionSearchSort = (sort) => {
	writeSavedSearchSort(sort);
	return {
		type: SEARCH_TRANSACTIONS_SORT_CHANGE,
		payload: sort
	};
};

const SEARCH_SORT_KEY = 'transactionSearchSort';

export function readSavedSearchSort() {
	try {
		return globalThis.localStorage?.getItem(SEARCH_SORT_KEY) || null;
	} catch(error) {
		return null;
	}
}

function writeSavedSearchSort(sort) {
	try {
		globalThis.localStorage?.setItem(SEARCH_SORT_KEY, sort);
	} catch(error) {
		// Private windows and blocked storage: the choice just lasts until reload.
	}
}

export const updateOfflineTransactionList = () => (dispatch, getState) => {
	dispatch({
		type: OFFLINE_TRANSACTION_LIST_UPDATE_BEGIN,
	});
	return getState().dashboard.transactionFinder.getOfflineTransactions().then((offlineTransactions) => {
		dispatch({
			type: OFFLINE_TRANSACTION_LIST_UPDATE_SUCCESS,
			payload: offlineTransactions
		});
	});
};

export const forceSendOfflineTransactionRequests = () => (dispatch, getState) => {
	dispatch({
		type: FORCE_SEND_OFFLINE_TRANSACTION_LIST_BEGIN
	});
	sendOfflinePostRequests()
		.then((results) => {
			dispatch({
				type: FORCE_SEND_OFFLINE_TRANSACTION_LIST_SUCCESS
			});
			dispatch(updateOfflineTransactionList());
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: FORCE_SEND_OFFLINE_TRANSACTION_LIST_FAIL
			});
		});
};

export const removeOfflineTransactionAttempt = (transaction) => (dispatch, getState) => {
	/**
	 * @type {TransactionFinder}
	 */
	const transactionFinder = getState().dashboard.transactionFinder;
	dispatch({
		type: OFFLINE_TRANSACTION_REMOVE_BEGIN
	});
	if(!transaction.submit_id) {
		dispatch({
			type: OFFLINE_TRANSACTION_REMOVE_FAIL
		});
		console.error('transaction is not an offline transaction');
		return;
	}

	TransactionStorage.removeItem(transaction.submit_id)
		.then(() => {
			transactionFinder.removeTransaction(transaction);
			dispatch({
				type: OFFLINE_TRANSACTION_REMOVE_SUCCESS
			});
			dispatch(updateOfflineTransactionList());
		})
		.catch((error) => {
			dispatch({
				type: OFFLINE_TRANSACTION_REMOVE_FAIL
			});
		});
};
/**
 * For the duplicates cleanup page: the pairs of transactions marked as not duplicates, lower id
 * first. Not kept in the store: only that page reads them.
 *
 * @returns {Promise<Array<[number, number]>>}
 */
export const fetchNotDuplicatePairs = () => Request.apiv1Get('budget/not_duplicate_transactions')
	.then((response) => response.pairs || []);

/** Marks every pair among the transactions as not duplicates, or with `mark` false, forgets them. Resolves with the pairs. */
export const markNotDuplicates = (transactionIds, mark = true) => Request.apiv1Post('budget/mark_not_duplicates', {
	transaction_ids: transactionIds,
	not_duplicates: mark ? 1 : 0,
}).then((response) => response.pairs || []);
